import React, { useLayoutEffect, useRef } from "react";
import { fullMonthFormatDate, signedLockedAccess } from "../../../../utils";
import style from "./assessmentNotes.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";
import { Button, TextArea } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";

export const NoteItem = ({
  data,
  assessmentStage,
  onDelete,
  hasPermission,
  onEdit,
  isEditing,
  onCancelEdit,
  onSaveEdit,
  editedNote,
  onEditChange,
  onKeyDown,
  updateNoteLoading,
}) => {
  const textAreaRef = useRef(null);

  useLayoutEffect(() => {
    if (isEditing && textAreaRef.current) {
      const el = textAreaRef.current;
      el.focus();

      const length = el.value.length;
      el.setSelectionRange(length, length);
    }
  }, [isEditing]);
  return (
    <div className={style.entered_notes}>
      <div className="d-flex justify-content-between align-items-center">
        <div className={style.post_details}>
          <span className={style.creater_name}>{data.createdBy}</span> | <span>{fullMonthFormatDate(data.createdDate)}</span> |{" "}
          <span>{data.createdByRole}</span>
        </div>

        <div className="d-flex gap-2">
          <button
            data-testid="editNote"
            className={`btn ${style.edit_icon}`}
            type="button"
            onClick={() => onEdit(data)}
            disabled={!signedLockedAccess(assessmentStage) || !hasPermission(PERMISSIONS.ASSESSMENT_NOTE_DELETE)}
          >
            <i className="fa fa-pencil" />
          </button>

          <button
            data-testid="deleteNote"
            className={`btn ${style.delete_icon}`}
            type="button"
            onClick={() => onDelete(data)}
            disabled={!signedLockedAccess(assessmentStage) || !hasPermission(PERMISSIONS.ASSESSMENT_NOTE_EDIT)}
          >
            <i className="fa fa-trash fa-lg" />
          </button>
        </div>
      </div>

      <div className={style.notes_text}>
        {isEditing ? (
          <>
            <TextArea
              id="edit-textarea"
              validator={textAreaRef}
              classes={{ inputClassName: style.textarea_box }}
              value={editedNote}
              onChange={onEditChange}
              onKeyDown={onKeyDown}
              rows={3}
            />

            <div className="d-flex justify-content-end w-100">
              <Button
                data-testid="edit-submit-btn"
                type="button"
                classes={{ className: `btn p-1 ${style.btn_primary} ${style.d_flex}` }}
                onClick={() => onSaveEdit(data.id)}
                disabled={updateNoteLoading}
              >
                {updateNoteLoading && <div className={style.spinner}></div>} {SAVE_BTN}
              </Button>
              <Button data-testid="edit-cancel-btn" type="button" classes={{ className: `btn p-1 ${style.btn_scondary}` }} onClick={onCancelEdit}>
                {CANCEL_BTN}
              </Button>
            </div>
          </>
        ) : (
          (data.notes || "Unknown").split("\n").map((line, i) => <div key={i}>{line}</div>)
        )}
      </div>
    </div>
  );
};
